<template>
  <module-page v-bind="pageParams">
    <template slot="header">
      <v-spacer></v-spacer>
      <select-field
        label=""
        class="my-auto bulletin__visualized-filter"
        v-model="visualizedFilter"
        :items="filterValues"
        selectKeyName="value"
        selectValueName="text"
      ></select-field>
    </template>
    <screen-loading v-if="loading && !hasBulletins"></screen-loading>
    <div v-else class="bulletins px-2">
      <expansion-panel-list
        expand
        openedOnReload
        :items="items"
        :hide-actions="mobile"
        v-if="items.length > 0 && !mobile"
        icon-class-modifier="bulletin--color"
        @togglePanel="viewItem"
        :filter="isFiltered"
      >
        <template slot="header" slot-scope="{ item }">
          <v-layout align-center justify-center row fill-height>
            <p
              class="bulletin__text"
              :class="{
                'bulletin__text_not-visualized': !visualized[item._id],
              }"
            >
              {{ item.title }}
            </p>
            <v-spacer></v-spacer>

            <div class="bulletin__date">
              {{ formatDate(item.lastModified) }}
            </div>
            <a
              v-if="mobile"
              @click="previewInBrowser(item)"
              class="bulletin__btn"
            >
              <i class="bexsicon-docs" />
            </a>
          </v-layout>
        </template>
        <template v-if="!mobile" slot="content" slot-scope="{ item }">
          <v-card class="bulletin">
            <a @click="previewInBrowser(item)" class="bulletin__btn">
              <i class="bexsicon-docs" />
            </a>
            <div class="bulletin__pdf">
              <div>
                <v-btn small flat icon @click="changePage(item._id, '-')">
                  <i class="bexsicon-left" />
                </v-btn>
                {{
                  `página ${pdfPages[item._id].currentPage}/${
                    pdfPages[item._id].pagesTotal
                  }`
                }}
                <v-btn small flat icon @click="changePage(item._id, '+')">
                  <i class="bexsicon-right" />
                </v-btn>
              </div>
              <pdf
                :src="item.attachment"
                :page="pdfPages[item._id].currentPage"
                @num-pages="(pages) => getNumberOfPages(pages, item._id)"
              ></pdf>
              <div>
                <v-btn small flat icon @click="changePage(item._id, '-')">
                  <i class="bexsicon-left" />
                </v-btn>
                {{
                  `página ${pdfPages[item._id].currentPage}/${
                    pdfPages[item._id].pagesTotal
                  }`
                }}
                <v-btn small flat icon @click="changePage(item._id, '+')">
                  <i class="bexsicon-right" />
                </v-btn>
              </div>
            </div>
          </v-card>
        </template>
      </expansion-panel-list>
      <div v-for="(item, i) in items" v-else-if="mobile" :key="i">
        <file-exhibition-card
          v-if="isFiltered(item)"
          :title="item.title"
          :date="item.lastModified"
          :visualized="!!visualized[item._id]"
          :themeColor="pageParams.themeColor"
          @previewFile="previewInBrowser(item)"
          buttonText="Exibir comunicado"
          buttonIcon="docs"
        ></file-exhibition-card>
      </div>
      <div v-if="items.length === 0 && !error" class="empty-state">
        {{ pageParams.emptyState }}
      </div>
      <div v-if="error" class="empty-state">
        {{ enums.responses.error }}
      </div>
    </div>
  </module-page>
</template>

<script>
import ModulePage from '@/components/layout/Page';
import FileExhibitionCard from '@/components/layout/FileExhibitionCard';
import ExpansionPanelList from '@/components/layout/ExpansionPanelList';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import { APP, BULLETINS, NOTIFICATIONS } from '@/utils/constants';
import bus from '@/utils/bus';
import SelectField from '@/components/fields/Select';
import notificationTypes from '@/utils/notificationTypes';
import pdf from 'vue-pdf';

export default {
  name: 'bulletins',
  components: {
    ModulePage,
    ExpansionPanelList,
    FileExhibitionCard,
    ScreenLoading,
    SelectField,
    pdf,
  },
  computed: {
    visualized() {
      return this.$store.getters[NOTIFICATIONS.GET_VISUALIZED];
    },
    items() {
      return this.$store.getters[BULLETINS.GET_BULLETINS];
    },
    hasBulletins() {
      return this.$store.getters[BULLETINS.HAS_BULLETINS];
    },
    pdfPages() {
      return this.$store.getters[BULLETINS.GET_PDF_PAGES];
    },
    loading() {
      return this.$store.getters[BULLETINS.IS_LOADING];
    },
    error() {
      return this.$store.getters[BULLETINS.HAS_ERROR];
    },
    filterValues() {
      return [
        { text: this.$t('pages.bulletin.filter.all'), value: null },
        { text: this.$t('pages.bulletin.filter.read'), value: true },
        { text: this.$t('pages.bulletin.filter.unread'), value: false },
      ];
    },
  },
  data() {
    return {
      pageParams: this.$store.getters[APP.PAGES].bulletins,
      visualizedFilter: null,
    };
  },
  created() {
    bus.$on('unit:change', this.getItems);
    bus.$on('unit:update', this.getItems);

    this.getItems();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.getItems);
    bus.$off('unit:update', this.getItems);
  },
  methods: {
    getNumberOfPages(pages, id) {
      if (!this.pdfPages[id]) this.pdfPages[id] = {};
      this.pdfPages[id].pagesTotal = pages || 1;
    },
    changePage(id, operator) {
      this.$store.commit(BULLETINS.CHANGE_PAGE, { id, operator });
      this.$forceUpdate();
    },
    getHeight() {
      return { height: `${window.innerHeight}px` };
    },
    viewItem({ item, isOpened, index }) {
      if (isOpened) {
        this.createTrace(this.enums.logTraceActions.bulletinsDownload, {
          title: item.title,
          attachment: item.attachment,
        });
        this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, {
          ctx: this,
          notification: { id: item._id, type: notificationTypes.BULLETIN },
        });
      }
    },
    isFiltered(item) {
      if (this.visualizedFilter == null) {
        return true;
      } else {
        return !!this.visualized[item._id] === this.visualizedFilter;
      }
    },
    previewInBrowser({ attachment, title, _id }) {
      window.open(attachment, '_blank');
      this.createTrace(this.enums.logTraceActions.bulletinsDownload, {
        title,
        attachment,
      });
      this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, {
        ctx: this,
        notification: { id: _id, type: notificationTypes.BULLETIN },
      });
      this.$forceUpdate();
    },
    async getItems(unitObj = null) {
      const params = {
        ...this.getByEnterpriseFromDateParams,
        desiredFields: {
          attachment: 1,
          createdAt: 1,
          lastModified: 1,
          title: 1,
        },
      };
      this.$store.dispatch(BULLETINS.FETCH_BULLETINS, params, unitObj);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/breakpoint';

.bulletin {
  background-color: #eeeeee !important;

  &__pdf {
    @include breakpoint(not-mobile) {
      padding: 5% 15%;
      width: 100%;
    }
  }

  &__text {
    color: var(--field-font-color) !important;
    display: block;
    font-size: 17px;
    margin: 0;

    &_not-visualized {
      font-weight: bold;
    }

    @include breakpoint(not-mobile) {
      display: initial;
    }
  }
  &__date {
    color: var(--field-font-color) !important;
    margin: 0 1em;
    // float: right;

    @include breakpoint(mobile) {
      position: absolute;
      right: 25%;
      top: 1em;
    }
  }

  &__btn {
    background-color: var(--bulletin-color) !important;
    color: #fff;
    position: absolute;
    right: 2em;
    top: 1em;
    width: 40px;
    z-index: 3;
    padding: 0.2em 0;
    border-top-left-radius: 5px !important;
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    text-align: center;
    height: 25px;
    margin-left: 10%;
  }

  .iframe-container {
    @include breakpoint(not-mobile) {
      position: inherit;
      &::before {
        content: '';
        position: absolute;
        z-index: 2;
        box-shadow: inset 0px -15px 0px 34px #eeeeee;
        right: 2%;
        left: 2%;
        height: 100%;
        pointer-events: none;
        top: 2%;
      }
    }
  }

  .iframe {
    min-width: 100%;
    border-radius: 5px;
    height: 100%;
    z-index: 1;
  }

  &__visualized-filter {
    padding: 0px;

    >>> .v-input__slot {
      border-color: var(--field-disabled-bg-color) !important;
      border-width: 1px;
      width: 200px;
      margin-top: auto;
      margin-bottom: 0;
      @include breakpoint(not-mobile) {
        margin-left: auto;
      }

      &:hover {
        border-color: var(--label-color) !important;
        border-width: 1px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/Bulletins.vue